import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'shared/hooks/useRouterPath';
import { APP_ROUTES } from 'shared/routes';

/**
 * True when the user is on the full-page Alvie AI Pro routes (`/ai` and nested).
 * Page-context drawer tools (inspect/highlight against the surrounding Alvie screen)
 * are not meaningful there.
 */
export const useIsCopilotStandalonePage = () => {
  const $ = _c(2);
  const {
    pathname
  } = usePathname();
  const base = APP_ROUTES.copilot.basePage;
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname === base || pathname.startsWith(`${base}/`);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};